module.exports = "<div class=calendar-remind-comment> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.remind.list/calendar.remind.list.html
// module id = 4922
// module chunks = 50